const respuesta_opciones = {
  "status": 200,
  "data": {
    "opciones": [
      {
        "nombre": "Documento externo",
        "iconoUrl": null,
        "tipo_esquema": "documento_externo"
      },
      {
        "nombre": "Documento administrativo",
        "iconoUrl": null,
        "tipo_esquema": "documento_administrativo"
      },
      {
        "nombre": "Documento interno",
        "iconoUrl": null,
        "tipo_esquema": "documento_interno"
      }
    ],
    "coleccion": "documentos_esquemas"
  },
  "message": "Documentos encontrados"
}

const respuesta_crear = {
  "status": 201,
  "data": {
    "docId": "bSGEP3h79p9JHvA2vr45"
  },
  "message": "Documento creado exitosamente"
}


const respuesta_leer = {
  "status": 200,
  "data": {
    "variables": [
      {
        "visible": true,
        "lista": null,
        "nombre": "Nombre",
        "lim_inferior": null,
        "limites": null,
        "obligatorio": false,
        "tipo": "string",
        "lim_superior": null,
        "grafica": null,
        "key": "z14097be9a",
        "valor": null,
        "variable": "variable1"
      },
      {
        "nombre": "Tipo contenido",
        "lim_inferior": null,
        "limites": null,
        "obligatorio": false,
        "tipo": "string",
        "lim_superior": null,
        "grafica": null,
        "key": "zed330571a",
        "valor": null,
        "variable": "variable2",
        "visible": true,
        "lista": null
      },
      {
        "nombre": "Extension",
        "lim_inferior": null,
        "limites": null,
        "obligatorio": false,
        "tipo": "string",
        "lim_superior": null,
        "grafica": null,
        "key": "z84f5b0f7a",
        "valor": null,
        "variable": "variable3",
        "visible": true,
        "lista": null
      },
      {
        "key": "z4c071dd5a",
        "valor": null,
        "variable": "variable4",
        "visible": true,
        "lista": null,
        "nombre": "Ubicacion",
        "lim_inferior": null,
        "limites": null,
        "obligatorio": false,
        "tipo": "string",
        "lim_superior": null,
        "grafica": null
      },
      {
        "obligatorio": false,
        "tipo": "lista",
        "lim_superior": null,
        "grafica": null,
        "key": "z3393b935a",
        "valor": null,
        "variable": "variable5",
        "visible": true,
        "lista": "clase_documento_externo",
        "nombre": "Clase documento externo",
        "lim_inferior": null,
        "limites": null,
        "opciones_lista": [
          {
            "valor": "Espirometría",
            "puntaje": null
          },
          {
            "valor": "Capnografía",
            "puntaje": null
          },
          {
            "valor": "Poligrafía",
            "puntaje": null
          },
          {
            "valor": "Otro",
            "puntaje": null
          }
        ]
      }
    ],
    "key": "documento_externo",
    "coleccion": "documentos"
  },
  "message": "Documento obtenido con éxito"
}


module.exports = {
  respuesta_opciones,
  respuesta_crear,
  respuesta_leer,
}


// WEBPACK FOOTER //
// ./src/components/SubirArchivoV2/MocksSubirArchivoV2.js